import { AdminGuard } from '@/components/admin-guard'
import { createFileRoute } from '@tanstack/react-router'
import { KbAdminListView } from '@/features/kb/KbAdminListView'
import { AdminSubNav } from '@/components/shell/AdminSubNav'

function KbAdmin() {
  return (
    <>
      <AdminSubNav />
      <KbAdminListView />
    </>
  )
}

export const Route = createFileRoute('/admin/kb/')({ component: () => (
    <AdminGuard>
      <KbAdmin />
    </AdminGuard>
  ) })
